import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReactMarkdown from 'react-markdown';

const FormExplain = ({ isOpen, onClose, markdownText, explanationType, model, serviceName }) => {
  const [mdText, setMdText] = useState(markdownText);
  const sourceLabel = [serviceName, model].filter(Boolean).join(' / ');

  useEffect(() => {
    // Update the markdown text when it changes
    setMdText(markdownText);
  }, [markdownText]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="explanation-dialog-title"
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'seashell',
          color: 'black',
          borderRadius: '10px',
          p: 2,
          // maxWidth: '350px',
          // maxHeight: '500px',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body1" component="div" id="explanation-dialog-title"
                    sx = {{fontSize: '1.25rem'}}
        >
          Explanation of {explanationType}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'black' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {sourceLabel && (
          <Typography variant="caption" component="div" sx={{ mb: 1, color: 'text.secondary' }}>
            {sourceLabel}
          </Typography>
        )}
        <ReactMarkdown>{mdText}</ReactMarkdown>
      </DialogContent>
    </Dialog>
  );
};

export default FormExplain;
